export default __webpack_public_path__ + "static/media/image.takas-lk.073c2504.png";